"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _config = _interopRequireDefault(require("../../config"));

var MODULE_NAME = 'sdk/portal/services/portal';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var SET_JWT_PORTAL_FAIL = 'SET_JWT_PORTAL_FAIL';
/**
 *
 * @param lang
 * @param scope
 * @returns Promise
 */

var getTranslation = function getTranslation(lang) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'netsapiens';
  logger.info("".concat(MODULE_NAME, " - getTranslation called"), {
    lang: lang,
    scope: scope
  });

  var _config$getConfigurat = _config.default.getConfiguration(),
      portalURL = _config$getConfigurat.portalURL;

  logger.debug("".concat(MODULE_NAME, " - getTranslation config"), {
    portalURL: portalURL
  });
  return _axios.default.post("".concat(portalURL, "webroot/locale/wp/").concat(lang, ".json")).then(function (res) {
    logger.debug("".concat(MODULE_NAME, " - getTranslation res"), true);
    return res.data;
  }).catch(function (err) {
    console.error(err);
    return false;
  });
};
/**
 * @returns Promise
 */


var removeToken = function removeToken() {
  logger.info("".concat(MODULE_NAME, " - removeToken called"));

  var _config$getConfigurat2 = _config.default.getConfiguration(),
      portalURL = _config$getConfigurat2.portalURL;

  logger.debug("".concat(MODULE_NAME, " - getToken config"), {
    portalURL: portalURL
  });
  return _axios.default.post("".concat(portalURL, "login/removejwt")).then(function () {
    logger.debug("".concat(MODULE_NAME, " - removeToken _setJwt res"), true);
    return true;
  }).catch(function (err) {
    console.error(err);
    return false;
  });
};
/**
 *
 * @returns {Promise}
 */


var ucCheck = function ucCheck() {
  logger.info("".concat(MODULE_NAME, " - ucCheck called"));

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured'); // eslint-disable-next-line prefer-promise-reject-errors

    return Promise.reject(false);
  }

  var _config$getConfigurat3 = _config.default.getConfiguration(),
      portalURL = _config$getConfigurat3.portalURL;

  logger.debug("".concat(MODULE_NAME, " - ucCheck config"), {
    portalURL: portalURL
  });
  return new Promise(function (resolve, reject) {
    _axios.default.get("".concat(portalURL, "login/uccheck")).then(function (res) {
      logger.debug("".concat(MODULE_NAME, " - ucCheck res"), res);
      resolve(res.data);
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - ucCheck err"), err);

      if (err && err.response && err.response.data) {
        reject(err.response.data);
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(false);
      }
    });
  });
};
/**
 *
 * @param {string} token
 * @returns {Promise}
 * @private
 */


var setJwt = function setJwt(token) {
  logger.info("".concat(MODULE_NAME, " - setJwt called"), {
    token: token
  });

  var _config$getConfigurat4 = _config.default.getConfiguration(),
      portalURL = _config$getConfigurat4.portalURL;

  logger.debug("".concat(MODULE_NAME, " - getToken config"), {
    portalURL: portalURL
  });
  return _axios.default.post("".concat(portalURL, "login/setjwt"), {
    token: token
  }).then(function () {
    logger.debug("".concat(MODULE_NAME, " - setJwt res"), true);
    return true;
  }).catch(function (err) {
    console.error(err);
    return false;
  });
};
/**
 *
 * @param {string} token
 * @returns {Promise}
 */


var updateSessionToken = function updateSessionToken(token) {
  logger.info("".concat(MODULE_NAME, " - updateSessionToken called"), {
    token: token
  });

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured'); // eslint-disable-next-line prefer-promise-reject-errors

    return Promise.reject(false);
  }

  return new Promise(function (resolve, reject) {
    setJwt(token).then(function (res) {
      logger.debug("".concat(MODULE_NAME, " - updateSessionToken setJwt res"), res);
      if (res) resolve(res);else reject(SET_JWT_PORTAL_FAIL);
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
};

var _default = {
  getTranslation: getTranslation,
  removeToken: removeToken,
  ucCheck: ucCheck,
  updateSessionToken: updateSessionToken
};
exports.default = _default;
module.exports = exports.default;